'use client';
import React, { useState } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import AppDownloadModal from '@/components/AppDownloadModal';
import ReviewersHero from './ReviewersHero';
import EarningsCalculator from './EarningsCalculator';
import ExperienceLevels from './ExperienceLevels';
import CategoryInterests from './CategoryInterests';
import ReviewersFAQ from './ReviewersFAQ';

export default function ForReviewersClient() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Header onDownloadClick={() => setModalOpen(true)} />
      <main>
        <ReviewersHero onCTAClick={() => setModalOpen(true)} />
        <EarningsCalculator onCTAClick={() => setModalOpen(true)} />
        <ExperienceLevels />
        <CategoryInterests />
        <ReviewersFAQ />
      </main>
      <Footer />
      <AppDownloadModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}